import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";
import { colours, font_families } from "./Styles";
import "./NotificationAnimation.css"; // Import the CSS file with animations
import { PurchaseModule } from "./PurchaseModules";
import { RichRoosterSticky } from "./Community";
import { ContactScreen } from "./ContactScreen";
import rich_rooster from "../images/newbird.png";

function Purchase() {
  const [direction, setDirection] = useState("row");
  const [mobileDevice, setMobileDevice] = useState(false);

  useEffect(() => {
    if (isMobile) {
      setDirection("column");
      setMobileDevice(true);
    }
  }, []);

  return (
    <div
      className="about"
      style={{
        paddingBottom: 200,
        fontFamily: font_families.roost,
        backgroundColor: "#f7c9e5",
      }}
    >
      <Helmet>
        <title>Community - Roost Game</title>
        <meta name="description" content="Join the Roost community" />
      </Helmet>

      <div className="container">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            fontFamily: "Gotham, sans-serif",
            fontWeight: "lighter",
            color: "#ed1a84",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              margin: 20,
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              padding: 20,
              textAlign: "center",
              backgroundColor: "#FFF",
            }}
          >
            <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex' }}>
              <div
                style={{
                  flex: 1,
                  textAlign: "center",
                  paddingRight: mobileDevice ? 0 : 20,
                }}
              >
                <h2 style={{ color: "#ed1a84" }}>
                  <b>Join the Flock</b>
                </h2>
                <p style={{ fontStyle: "italic", fontWeight: "350", color: "#444", fontSize: "14px", fontWeight: "lighter",}}>
                  Stay at top of the pecking order by joining the mailing list
                </p>
                <PurchaseModule />
              </div>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: mobileDevice ? 20 : 0,
                  width: "100%",
                }}
              >
                <img
                  src={rich_rooster}
                  alt="Rich Rooster"
                  style={{
                    width: mobileDevice ? "60%" : "120px",
                    maxWidth: "100%",
                  }}
                />
                <p
                  style={{
                    fontSize: "12px",
                    marginTop: 10,
                    color: 'black'
                  }}
                >
                  Sign up to our mailing list for a free Rich Rooster card*
                </p>
              </div>
            </div>
            <ContactScreen/>
          </div>
          
        </div>

      </div>

      <div style={{ padding: 20, marginTop: 30 }}>
        <p style={{ fontSize: 10 }}>
          * You must purchase a copy of Roost to obtain the Rich Rooster card.
          Rich Rooster will be delivered with your copy of Roost if purchased
          via this website.
        </p>
      </div>
    </div>
  );
}

export default Purchase;
